export enum CargoCompanyListParamsOrder {
  COMPANY_NAME_ASC = "COMPANY_NAME_ASC",
  COMPANY_NAME_DESC = "COMPANY_NAME_DESC",
  COMPANY_DISPLAY_NAME_ASC = "COMPANY_DISPLAY_NAME_ASC",
  COMPANY_DISPLAY_NAME_DESC = "COMPANY_DISPLAY_NAME_DESC",
}

type CargoCompanyListParams = {
  taxNumber?: string;
  companyId?: string;
  nationalCourtRegister?: string;
  companyName?: string;
  companyDisplayName?: string;
  address?: string;
  notes?: string;
  order?: CargoCompanyListParamsOrder;
  creationStart?: Date;
  creationEnd?: Date;
};

export default CargoCompanyListParams;
